export const appURL = process.env.REACT_PUBLIC_URL
  ? process.env.REACT_PUBLIC_URL
  : "http://localhost:3000";

export const apiURL = process.env.REACT_APP_API_URL_v2
  ? process.env.REACT_APP_API_URL_v2
  : "https://api.simplicapital.ai/api/";
